/*!

=========================================================
* Black Dashboard PRO React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-pro-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";

import {Redirect} from "react-router-dom"
import{withAuth0} from "@auth0/auth0-react"

// reactstrap components
import {
  Button,
  Collapse,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  Input,
  InputGroup,
  NavbarBrand,
  Navbar,
  Nav,
  Container,
  Modal,
  UncontrolledTooltip,
  Tooltip
} from "reactstrap";

import {NavLink} from "react-router-dom";

class AdminNavbar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      collapseOpen: false,
      modalSearch: false,
      color: "navbar-transparent",
      btn1Tooltip:false,
      btn2Tooltip:false,
      btn3Tooltip:false,
    };
  }
  componentDidMount() {
    window.addEventListener("resize", this.updateColor);
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateColor);
  }
  // function that adds color white/transparent to the navbar on resize (this is for the collapse)
  updateColor = () => {
    if (window.innerWidth < 993 && this.state.collapseOpen) {
      this.setState({
        color: "bg-white"
      });
    } else {
      this.setState({
        color: "navbar-transparent"
      });
    }
  };
  // this function opens and closes the collapse on small devices
  toggleCollapse = () => {
    if (this.state.collapseOpen) {
      this.setState({
        color: "navbar-transparent"
      });
    } else {
      this.setState({
        color: "bg-white"
      });
    }
    this.setState({
      collapseOpen: !this.state.collapseOpen
    });
  };
  // this function is to open the Search modal
  toggleModalSearch = () => {
    this.setState({
      modalSearch: !this.state.modalSearch
    });
  };
  toggleBtn1 = () => {
    this.setState({
      btn1Tooltip: !this.state.btn1Tooltip
    });
  }
  toggleBtn2 = () => {
    this.setState({
      btn2Tooltip: !this.state.btn2Tooltip
    });
  }
  toggleBtn3 = () => {
    this.setState({
      btn3Tooltip: !this.state.btn3Tooltip
    });
  }
  render() {
    const { user } = this.props.auth0;
    return (
      <>
        <Navbar
          className={classNames("navbar-absolute", {
            [this.state.color]:
              this.props.location.pathname.indexOf("full-screen-map") === -1
          })}
          expand="lg"
        >
          <Container fluid>
            <div className="navbar-wrapper">
              <div className="navbar-minimize d-inline">
                <Button
                  className="minimize-sidebar btn-just-icon"
                  color="link"
                  id="tooltip209599"
                  onClick={this.props.handleMiniClick}
                >
                  <i className="tim-icons icon-align-center visible-on-sidebar-regular" />
                  <i className="tim-icons icon-bullet-list-67 visible-on-sidebar-mini" />
                </Button>
                <UncontrolledTooltip
                  delay={0}
                  target="tooltip209599"
                  placement="right"
                >
                  Sidebar toggle
                </UncontrolledTooltip>
              </div>
              <div
                className={classNames("navbar-toggle d-inline", {
                  toggled: this.props.sidebarOpened
                })}
              >
                <button
                  className="navbar-toggler"
                  type="button"
                  onClick={this.props.toggleSidebar}
                >
                  <span className="navbar-toggler-bar bar1" />
                  <span className="navbar-toggler-bar bar2" />
                  <span className="navbar-toggler-bar bar3" />
                </button>
              </div>
              <NavbarBrand href="" onClick={e => e.preventDefault()}>
                {this.props.brandText}
              </NavbarBrand>
            </div>
            <button
              className="navbar-toggler"
              type="button"
              data-toggle="collapse"
              data-target="#navigation"
              aria-expanded="false"
              aria-label="Toggle navigation"
              onClick={this.toggleCollapse}
            >
              <span className="navbar-toggler-bar navbar-kebab" />
              <span className="navbar-toggler-bar navbar-kebab" />
              <span className="navbar-toggler-bar navbar-kebab" />
            </button>
            <Collapse navbar isOpen={this.state.collapseOpen}>
              <Nav className="ml-auto" navbar>
                <InputGroup className="search-bar" tag="li">
                  <div id='btn1'>
                    <Button disabled className="btn-round btn-icon" color="tumblr">
                      <i className="tim-icons icon-tv-2" />
                    </Button>
                    <Tooltip placement="right" isOpen={this.state.btn1Tooltip} target="btn1" toggle={this.toggleBtn1}>
                      Live Module Is Disabled, Please Contact Support To Enable It
                    </Tooltip>
                  </div>
                  <div id='btn2'>
                  <Button disabled className="btn-round btn-icon" color="tumblr">
                    <i className="tim-icons icon-video-66" />
                  </Button>
                  <Tooltip placement="right" isOpen={this.state.btn2Tooltip} target="btn2" toggle={this.toggleBtn2}>
                      Call Recording Module Is Disabled, Please Contact Support To Enable It
                    </Tooltip>
                  </div>
                  <div id='btn3'>
                  <Button disabled className="btn-round btn-icon" color="tumblr">
                    <i className="tim-icons icon-badge" />
                  </Button>
                  <Tooltip placement="right" isOpen={this.state.btn3Tooltip} target="btn3" toggle={this.toggleBtn3}>
                      Meeting Module Is Disabled, Please Contact Support To Enable It
                    </Tooltip>
                  </div>
                </InputGroup>
                {/* <UncontrolledDropdown nav>
                  <DropdownToggle
                    caret
                    color="default"
                    data-toggle="dropdown"
                    nav
                  >
                    <div className="notification d-none d-lg-block d-xl-block" />
                    <i className="tim-icons icon-sound-wave" />
                    <p className="d-lg-none">Notifications</p>
                  </DropdownToggle>
                  <DropdownMenu className="dropdown-navbar" right tag="ul">
                  </DropdownMenu>
                </UncontrolledDropdown> */}
                <UncontrolledDropdown nav>
                  <DropdownToggle
                    caret
                    color="default"
                    data-toggle="dropdown"
                    nav
                  >
                    <div className="photo">
                      <img alt="..." src={user.picture} />
                    </div>
                    <b className="caret d-none d-lg-block d-xl-block" />
                    <p className="d-lg-none">Log out</p>
                  </DropdownToggle>
                  <DropdownMenu className="dropdown-navbar" right tag="ul">
                    {/*<NavLink to="#" tag="li">
                      <DropdownItem className="nav-item">Profile</DropdownItem>
                    </NavLink>
                    <NavLink to="#" tag="li">
                      <DropdownItem className="nav-item">Settings</DropdownItem>
                    </NavLink>
                   <DropdownItem divider tag="li" />*/}
                   <NavLink to="/auth0-logout">
                      <DropdownItem className="nav-item">Log out</DropdownItem>
                   </NavLink>
                  </DropdownMenu>
                </UncontrolledDropdown>
                <li className="separator d-lg-none" />
              </Nav>
            </Collapse>
          </Container>
        </Navbar>
        <Modal
          modalClassName="modal-search"
          isOpen={this.state.modalSearch}
          toggle={this.toggleModalSearch}
        >
          <div className="modal-header">
            <Input id="inlineFormInputGroup" placeholder="SEARCH" type="text" />
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={this.toggleModalSearch}
            >
              <i className="tim-icons icon-simple-remove" />
            </button>
          </div>
        </Modal>
      </>
    );
  }
}

export default withAuth0(AdminNavbar);
